export const PARTNER_TYPE_DESCRIPTION = [
  { key: 'Distributor', value: 'Partner is holding an active HW Distributor Contract' },
  {
    key: 'Supplies Distributor',
    value: 'Partner is holding an active Supplies Distributor Contract',
  },
  { key: 'Direct Retailer', value: 'Partner is Holding a Direct buying Retailer Contract' },
  { key: 'PF Platinum Partner', value: 'Partner is holding a Platinum Partner First Status' },
  { key: 'PF Gold Partner', value: 'Partner is holding a Gold Partner First Status' },
  { key: 'PF Silver Partner', value: 'Partner is holding a Silver Partner First Status' },
  { key: 'PF Specialist Partner', value: 'Partner is holding a Specialist Partner First Status' },
  {
    key: 'Other Corporate Reseller',
    value:
      'Partner is holding a direct buying reseller contract but not part of Partner First program',
  },
  {
    key: 'Proximity with Contract',
    value: 'Partner is holding a T2 reseller contract but not part of Partner First program',
  },
  { key: 'Other Indirect Retailer', value: 'Partner is holding a T2 Retailer Contract' },
  {
    key: 'Other Contracted Partner',
    value:
      'Partner is holding OEM or other type of contract, not a retailer, distributor or reseller',
  },
  { key: 'Business partner', value: 'Partner is holding a Business Partner Program Status' },
  { key: 'Marketing Agency', value: 'Partner is a Marketing Service Agency' },
  {
    key: 'DUMMY PARTNER',
    value: 'Partner is a test record or Regional HQ setup for reporting roll up',
  },
  {
    key: 'Proximity With Active Contract',
    value: 'Partner is holding an active contract but not part of any program',
  },
  {
    key: 'Proximity without contract',
    value: 'Partner is not holding any active contract and neither is part of any program',
  },
]

export const AMPLYFY_PROGRAM = ['Power', 'Synergy', 'Power CDR', 'Power Services']

export const PRB_ROLES = ['PBM', 'Read Only']

export const BLACKLIST_FLAG = 'EU-DI-PSG-SBSO-BLACKLIST'

export const EXTENDED_ATTR_SECOND = 'BP Not Addressable'
